<template>
    <DefaultHeader />
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-6">
            </div>
            <div class="col-md-6">
                <div class="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
                    <div>
                        <ButtonDisplay text="Nouveau contact" type="add" @click="adding = !adding" />
                    </div>
                </div>
            </div>
        </div>


        <div v-if="adding" class="row d-flex justify-content-center">
            <div class="col-xl-3 col-sm-6">
                <ContactCard :type="'email'"/>
            </div>
        </div>


        <div class="row">
            <div class="col-xl-3 col-sm-6">
                <ContactCard :type="'email'"/>
            </div>
            <div class="col-xl-3 col-sm-6">
                <ContactCard :type="'email'"/>
            </div>
            <div class="col-xl-3 col-sm-6">
                <ContactCard :type="'mobile'"/>
            </div>
            <div class="col-xl-3 col-sm-6">
                <ContactCard :type="'email'"/>
            </div>
            <div class="col-xl-3 col-sm-6">
                <ContactCard :type="'mobile'"/>
            </div>
            <div class="col-xl-3 col-sm-6">
                <ContactCard :type="'email'"/>
            </div>
            <div class="col-xl-3 col-sm-6">
                <ContactCard :type="'mobile'"/>
            </div>
            <div class="col-xl-3 col-sm-6">
                <ContactCard :type="'email'"/>
            </div>
        </div>
    </div>

    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import ContactCard from './Sections/ContactCard.vue'


export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        ButtonDisplay,
        ContactCard
    },
    data() {
        return {
            adding: false,
        };
    },
}
</script>

<style>
.card {
    margin-bottom: 24px;
    box-shadow: 0 2px 3px #e4e8f0;
}

.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid #eff0f2;
    border-radius: 1rem;
}

.avatar-md {
    height: 4rem;
    width: 4rem;
}

.rounded-circle {
    border-radius: 50% !important;
}

.img-thumbnail {
    padding: 0.25rem;
    background-color: #f1f3f7;
    border: 1px solid #eff0f2;
    border-radius: 0.75rem;
}

.avatar-title {
    align-items: center;
    background-color: #3b76e1;
    color: #fff;
    display: flex;
    font-weight: 500;
    height: 100%;
    justify-content: center;
    width: 100%;
}

.bg-soft-primary {
    background-color: rgba(59, 118, 225, .25) !important;
}

a {
    text-decoration: none !important;
}

.badge-soft-danger {
    color: #f56e6e !important;
    background-color: rgba(245, 110, 110, .1);
}

.badge-soft-success {
    color: #63ad6f !important;
    background-color: rgba(99, 173, 111, .1);
}

.mb-0 {
    margin-bottom: 0 !important;
}

.badge {
    display: inline-block;
    padding: 0.25em 0.6em;
    font-size: 75%;
    font-weight: 500;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.75rem;
}
</style>